import Dialog from "./Modal";

export default Dialog;
